<script>
export default {
  name: 'SegmentationDefaultIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
    colorInternal: {
      type: String,
      default: '#fff',
    },
  },
  computed: {
    // ID único por instância (this._uid é garantido único por componente Vue
    // durante a vida da app). O id fixo original (copiado de export do Figma)
    // colide quando o mesmo ícone renderiza mais de uma vez na mesma página,
    // invalidando o clip-path nas instâncias duplicadas.
    clipId() {
      return `clip0_5192_145063_${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="6" y="6" width="11" height="11" :fill="color" />
    <path
      d="M18.5408 4.17001L13.0408 2.11001C12.4708 1.90001 11.5408 1.90001 10.9708 2.11001L5.47078 4.17001C4.41078 4.57001 3.55078 5.81001 3.55078 6.94001V15.04C3.55078 15.85 4.08078 16.92 4.73078 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4508 5.81001 19.5908 4.57001 18.5408 4.17001ZM12.0008 16.25C9.38078 16.25 7.25078 14.12 7.25078 11.5C7.25078 8.88001 9.38078 6.75001 12.0008 6.75001C14.6208 6.75001 16.7508 8.88001 16.7508 11.5C16.7508 14.12 14.6208 16.25 12.0008 16.25Z"
      :fill="color"
    />
    <g :clip-path="`url(#${clipId})`">
      <path
        d="M16.6512 9.95349C16.4605 9.95349 16.3023 9.79535 16.3023 9.60465V8.67442C16.3023 7.47442 15.5256 6.69767 14.3256 6.69767H9.67442C8.47442 6.69767 7.69767 7.47442 7.69767 8.67442V9.60465C7.69767 9.79535 7.53953 9.95349 7.34884 9.95349C7.15814 9.95349 7 9.79535 7 9.60465V8.67442C7 7.07442 8.07442 6 9.67442 6H14.3256C15.9256 6 17 7.07442 17 8.67442V9.60465C17 9.79535 16.8419 9.95349 16.6512 9.95349Z"
        :fill="colorInternal"
      />
      <path
        d="M14.3256 16H9.67442C8.07442 16 7 14.9256 7 13.3256V12.3953C7 12.2046 7.15814 12.0465 7.34884 12.0465C7.53953 12.0465 7.69767 12.2046 7.69767 12.3953V13.3256C7.69767 14.5256 8.47442 15.3023 9.67442 15.3023H14.3256C15.5256 15.3023 16.3023 14.5256 16.3023 13.3256V12.3953C16.3023 12.2046 16.4605 12.0465 16.6512 12.0465C16.8419 12.0465 17 12.2046 17 12.3953V13.3256C17 14.9256 15.9256 16 14.3256 16Z"
        :fill="colorInternal"
      />
      <path
        d="M14.0465 9.23717L12.2977 8.29298C12.1116 8.19531 11.893 8.19531 11.707 8.29298L9.95349 9.23717C9.82791 9.30694 9.74884 9.44182 9.74884 9.59066C9.74884 9.73949 9.82791 9.87903 9.95349 9.9488L11.7023 10.893C11.7954 10.9441 11.8977 10.9674 12 10.9674C12.1023 10.9674 12.2047 10.9441 12.2977 10.893L14.0465 9.9488C14.1721 9.87903 14.2512 9.74415 14.2512 9.59066C14.2512 9.43717 14.1721 9.30694 14.0465 9.23717Z"
        :fill="colorInternal"
      />
      <path
        d="M11.414 11.2186L9.78605 10.4047C9.66047 10.3442 9.51628 10.3489 9.39535 10.4233C9.27907 10.4977 9.2093 10.6233 9.2093 10.7628V12.3024C9.2093 12.5675 9.35814 12.8093 9.59535 12.9256L11.2233 13.7396C11.2791 13.7675 11.3395 13.7814 11.4047 13.7814C11.4791 13.7814 11.5488 13.7628 11.614 13.721C11.7349 13.6466 11.8047 13.521 11.8047 13.3814V11.8419C11.8 11.5768 11.6558 11.3396 11.414 11.2186Z"
        :fill="colorInternal"
      />
      <path
        d="M14.6 10.4233C14.4791 10.3489 14.3349 10.3442 14.2093 10.4047L12.5814 11.2186C12.3442 11.3396 12.1954 11.5768 12.1954 11.8419V13.3814C12.1954 13.521 12.2651 13.6466 12.386 13.721C12.4512 13.7628 12.5209 13.7814 12.5954 13.7814C12.6558 13.7814 12.7163 13.7675 12.7767 13.7396L14.4047 12.9256C14.6419 12.8047 14.7907 12.5675 14.7907 12.3024V10.7628C14.7907 10.6233 14.7209 10.4977 14.6 10.4233Z"
        :fill="colorInternal"
      />
    </g>
    <defs>
      <clipPath :id="clipId">
        <rect
          width="10"
          height="10"
          :fill="colorInternal"
          transform="translate(7 6)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
